import React, {useState, useMemo} from 'react';

import './CitationTable.css';

export interface MyComponentProps {
  // Define your prop types here
  yValueType?: any,
  xValueType?: any
  xValues: any,
  xValueIds: any[],
  yValues: any,
  yValueIds: any[],
  countHash: any,
  handleCellClick?: any,
  handleXClick?: any,
  handleYClick?: any,
  handleXParentSelect?: any,
  handleYParentSelect?: any,
  getExpressionTypes?: any
  tableStyle?: any
  

}

export const CitationTable: React.FC<MyComponentProps> = ({xValues, xValueIds, yValues, yValueIds, countHash, handleCellClick, handleXClick, handleYClick, handleXParentSelect, handleYParentSelect, yValueType, xValueType, getExpressionTypes, tableStyle}) => {
  
  const [xFrequencySortYValue, setXFrequencySortYValue] = useState<string>("")
  const [yFrequencySortXValue, setYFrequencySortXValue] = useState<string>("")
  const [yIntersectionValue, setYIntersectionValue] = useState<string>("")
  const [xIntersectionValue, setXIntersectionValue] = useState<string>("")

  const activeYIds = useMemo(() => {
    if (!yValueIds || !xValueIds) return [];
    return yValueIds.filter((y: any) =>
        xValueIds.filter((x: any) => {
          if (yIntersectionValue){
            return (parseInt(countHash[y][x] || 0) > 0 && parseInt(countHash[yIntersectionValue][x] || 0) > 0)
          } else {
            return true
          }
        }).length >= 1
      );
  }, [yValueIds, xValueIds, xValues, yValues, countHash, yIntersectionValue]);

  const activeXIds = useMemo(() => {
    if (!xValueIds || !yValueIds) return [];
    return xValueIds.filter((x: any) =>
        yValueIds.filter((y: any) => {
          if (xIntersectionValue){
            return (parseInt(countHash[y][x] || 0) > 0 && parseInt(countHash[y][xIntersectionValue] || 0) > 0)
          } else {
            return true
          }
        }).length >= 1
      );
  }, [yValueIds, xValueIds, xValues, yValues, countHash, xIntersectionValue]);


  const sortIds = (ids: any[], hash: any, type: string, valuesType: string) => {
    if (xFrequencySortYValue && type === "xFrequency") {
      if (xFrequencySortYValue === "total"){
        return sortXIdsByTotalFrequency(ids)
      }
      else{
        return sortXIdsByFrequency(ids)
      }
    }
    else if (yFrequencySortXValue && type === "yFrequency") {
      if (yFrequencySortXValue === "total"){
        return sortYIdsByTotalFrequency(ids)
      }
      else{
        return sortYIdsByFrequency(ids)
      }
    }
    else{
      if (valuesType === "y" && (yValueType === "ExpressionType" || yValueType === "WorkGroup")){
        return sortIdsByAuthorDate(ids,hash)
      }
      if (valuesType === "x" && (xValueType === "ExpressionType" || xValueType === "WorkGroup")){
        return sortIdsByAuthorDate(ids,hash)
      }
      else{
        return sortIdsByOrder(ids, hash)
      }
    }
    
  }
  const sortIdsByOrder = (ids: any[], hash: any) => {
    const sortedArray = ids.sort((a,b) => {
      if (hash[a].order > hash[b].order){
        return 1
      }
      else if (hash[a].order < hash[b].order){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }
  const sortIdsByAuthorDate = (ids: any[], hash: any) => {
    const sortedArray = ids.sort((a,b) => {
      if (hash[a].authorBirthDate > hash[b].authorBirthDate){
        return 1
      }
      else if (hash[a].authorBirthDate < hash[b].authorBirthDate){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }

  const sortXIdsByFrequency = (ids: any[]) => {
    const y: string = xFrequencySortYValue
    const sortedArray = ids.sort((a,b) => {
      const a2 = (countHash[y] && countHash[y][a]) ? parseInt(countHash[y][a]) : 0
      const b2 = (countHash[y] && countHash[y][b]) ? parseInt(countHash[y][b]) : 0
      if (a2 < b2){
        return 1
      }
      else if (a2 > b2){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }
  const sortXIdsByTotalFrequency = (ids: any[]) => {
    // const y: string = xFrequencySortYValue
    const sortedArray = ids.sort((a,b) => {
      const a2 = getXTotals(a)
      const b2 = getXTotals(b)
      if (a2 < b2){
        return 1
      }
      else if (a2 > b2){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }
  const sortYIdsByFrequency = (ids: any[]) => {
    const x: string = yFrequencySortXValue
    const sortedArray = ids.sort((a,b) => {
      const a2 = countHash[a][x] ? parseInt(countHash[a][x]) : 0
      const b2 = countHash[b][x] ? parseInt(countHash[b][x]) : 0
      if ((a2 < b2)){
        return 1
      }
      else if (a2 > b2){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }
  const sortYIdsByTotalFrequency = (ids: any[]) => {
    // const x = yFrequencySortXValue
    const sortedArray = ids.sort((a,b) => {
      const a2 = getYTotals(a)
      const b2 = getYTotals(b)
      if (a2 < b2){
        return 1
      }
      else if (a2 > b2){
        return -1
      }
      else{
        return 0
      }
    })
    return sortedArray
  }

  const displayRows = () => {
    const rows = activeYIds && sortIds(activeYIds, yValues, "yFrequency", "y").map((y:any) => {
      return (
        <tr key={"row-" + y} style={yIntersectionValue && yIntersectionValue === y ? {"backgroundColor": "lightblue"} : {}}>
          {
            displayYLabel(y)
          }
          {
          sortIds(activeXIds, xValues, "xFrequency", "x").map((x:any) => {
            return (
              displayCells(x, y)
            )
          })
        }
        <td>{getYTotals(y)}</td>
      </tr>
      
      )
    })
    return rows
  }

  // const displayRows = () => {
  //   const rows = yValueIds && sortIds(yValueIds, yValues, "yFrequency", "y")
  //   .filter((y: any) =>
  //     sortIds(xValueIds, xValues, "xFrequency", "x").filter((x: any) => {
  //       if (yIntersectionValue){
  //         return (parseInt(countHash[y][x] || 0) > 0 && parseInt(countHash[yIntersectionValue][x] || 0) > 0)
  //       }
  //       else{
  //         return true
  //       }
  //     }
  //     ).length >= 1
  //   ).map((y:any) => {
  //     return (
  //       <tr key={"row-" + y} style={yIntersectionValue && yIntersectionValue === y ? {"backgroundColor": "lightblue"} : {}}>
  //         {
  //           displayYLabel(y)
  //         }
  //         {
  //         sortIds(xValueIds, xValues, "xFrequency", "x").map((x:any) => {
  //           return (
  //             displayCells(x, y)
  //           )
  //         })
  //       }
  //       <td>{getYTotals(y)}</td>
  //     </tr>
      
  //     )
  //   })
  //   return rows
  // }
  
  const displayCells = (x:any, y:any) => {

    function sigmoid(z:any) {
      const k = 20
      return (1 / (1 + Math.exp(-z/k)));
    }
    const count = countHash[y][x] ? parseInt(countHash[y][x]) : 0
    const sigmoidNumber = sigmoid(count)
    
    const r = (1 - (sigmoidNumber - 0.5)) * 255
    const g = (1- (sigmoidNumber - 0.3)/2) * 255
    const b = (1 - (sigmoidNumber - 0.2)/3) * 255
    const backgroundColor = "rgb(" + r + " " + g + " " + b + ")";

    const longLabel = yValues[y].authorTitle + ", " + yValues[y].longTitle + " --> " + xValues[x].authorTitle + ", " + xValues[x].longTitle
    return (
      <td key={"cell-" + y + "-" + x} style={{"backgroundColor": backgroundColor, "cursor": "pointer"}} title={longLabel}><span onClick={() => {handleCellClick(y, yValues[y]?.startCurrentLevel, x, xValues[x]?.sourceCurrentLevel)}}>{countHash[y][x]}</span></td>
    )
  }
  const displayYLabel = (y:any) => {
    const label = yValues[y].authorTitle + ", " + yValues[y].title
    const longLabel = yValues[y]?.authorTitle + ", " + yValues[y].longTitle
    return (
      <td className="yLabel">
        {!longLabel.includes("Paragraph") 
          ? 
          <span style={{cursor: "pointer"}} onClick={() => {handleYClick(y, yValues[y].startCurrentLevel)}} title={longLabel}>{label}</span> 
          :
          <span title={longLabel}>{label}</span>
        }
        <span onClick={() => setXFrequencySortYValue(y)}> S </span> 
        | <span onClick={() => setYIntersectionValue(y)}> I </span> 
        {/* temp commented because I don't have a real use for this right now {yValueType !== "ExpressionType" && <span onClick={() => {getExpressionTypes(y)}}>ET</span>} */}
        </td>
    )
  }

  const getXTotals = (xValue: any) => {
    let total = 0;
    Object.keys(countHash).forEach((y) => {
      if (countHash[y][xValue]){
        total += parseInt(countHash[y][xValue])
      }
      
    })
    return total

  }
  const getYTotals = (yValue: any) => {
    let total = 0;
    Object.keys(countHash[yValue]).forEach((x) => {
      total += parseInt(countHash[yValue][x])
    })
    return total
  }

  const displayXTotals = () => {
      let runningTotal = 0
      function getNewTotal(x: any){
        const total = getXTotals(x)
        runningTotal += total
        return total
      }
      return (
        <tr key={"row-total"}>
          <td className="xLabel"><span>Total</span> <span onClick={() => setXFrequencySortYValue("total")}> S </span></td>
          {/* <td key="column-total" className="xLabel"><span>Total</span></td> */}
          {
          xValueIds && sortIds(xValueIds, xValues, "xFrequency", "x").map((x:any) => {
            return (
              <td key={x + "-total"}>{getNewTotal(x)}</td>
            )
          })
        }
        <td>{runningTotal}</td>
      </tr>
      
      )
  }
  
  return(
    <table style={tableStyle}>
        <tbody>
        <tr key="head-row">
          <td key="head-row-cell-0" className="xLabel">
            {yValueType === "TopLevelExpression" && <span style={{cursor: "pointer"}} onClick={()=> handleYParentSelect(yValues[Object.keys(yValues)[0]].startParent, yValues[Object.keys(yValues)[0]].startCurrentLevel)}>Y-up</span>} {xValueType === "TopLevelExpression" && <span style={{cursor: "pointer"}} onClick={()=> handleXParentSelect(xValues[Object.keys(xValues)[0]].sourceParent, xValues[Object.keys(xValues)[0]].sourceCurrentLevel)}>X-up</span>}
            <br/><span style={{cursor: "pointer"}} onClick={() => setYFrequencySortXValue("")}>Clear Y Sort</span> | 
            <span onClick={() => setYIntersectionValue("")}>Clear Y Int </span> |
            <span style={{cursor: "pointer"}} onClick={() => setXFrequencySortYValue("")}>Clear X Sort</span> | 
            <span onClick={() => setXIntersectionValue("")}>Clear X Int </span> |
            </td>
            {activeXIds && sortIds(activeXIds, xValues, "xFrequency", "x").map((x:any, i:any) => {
              const label = xValues[x].authorTitle + ", " + xValues[x].title
              const longLabel = xValues[x].authorTitle + ", " + xValues[x].longTitle
              return (
              <td key={"head-row-cell-" + i} className="xLabel" style={xIntersectionValue && xIntersectionValue === x ? {"backgroundColor": "lightblue"} : {}}>
                {!longLabel.includes("Paragraph") 
                  ? 
                  <span style={{cursor: "pointer"}} onClick={() => {handleXClick(x, xValues[x].sourceCurrentLevel)}} title={longLabel}>{label}</span>
                  : 
                  <span title={longLabel}>{label}</span>
                }
                <span onClick={() => setYFrequencySortXValue(x)}> S </span> |
                <span onClick={() => setXIntersectionValue(x)}> I </span>
              </td>
              
              )
            })
            }
            <td className="xLabel"><span>Total</span> <span onClick={() => setYFrequencySortXValue("total")}> S </span></td>
        </tr>
        {displayRows()}
        {displayXTotals()}
        

        </tbody>
      </table>
  )
}